import * as dashApi from "./dashApiService";
import { summaryReportKeys } from "../configs/storageKeys.json";
import * as systemService from "./systemService";
import { toast } from "react-toastify";
import { toastConfig } from "../configs/toastConfig";

let summaryDefinitions = [];

let isOnChartScreenValue = false;

function getSummaryDefinitions() {
	if (summaryDefinitions || summaryDefinitions.length === 0) {
	} else {
		summaryDefinitions = loadSummaryDefinitionsFromStorage();
	}

	return summaryDefinitions;
}

function loadSummaryDefinitions() {
	return new Promise((resolve, reject) => {
		dashApi
			.getSummaryDefinition()
			.then((response) => {
				if (response.success === true) {
					const definitions = response.data;
					saveSummaryDefinitionToStorage(definitions);
					resolve(response);
				} else {
					console.error(response.err);
					toast.error(
						<>
							<p className="mb-1">There was an error loading your data.</p>
							<p className="mb-1">
								Please make sure that you have a good connection to the internet
								and try again.
							</p>
							<p>
								If the problem persists, please contact our helpdesk, quoting
								reference '#SR001'.
							</p>
						</>,
						{
							toastId: toastConfig.toastIds.errLoad,
						}
					);

					reject(response);
				}
			})
			.catch(() => {
				toast.error(
					<>
						<p className="mb-1">There was an error loading your data.</p>
						<p className="mb-1">
							Please make sure that you have a good connection to the internet
							and try again.
						</p>
						<p>
							If the problem persists, please contact our helpdesk, quoting
							reference '#SR002'.
						</p>
					</>,
					{
						toastId: toastConfig.toastIds.errNetwork,
					}
				);

				reject();
			});
	});
}

function saveSummaryDefinitionToStorage(def) {
	systemService.saveToSessionStorage(summaryReportKeys.def, def);
}

function loadSummaryDefinitionsFromStorage() {
	const defs = systemService.loadFromSessionStorage(summaryReportKeys.def);
	return defs ?? [];
}

function getTimechartData(code, selector) {
	return new Promise((resolve, reject) => {
		dashApi
			.getTimechartData(code, selector)
			.then((response) => {
				if (response.success === true) {
					resolve(response.data);
				} else {
					reject(response);
				}
			})
			.catch(reject);
	});
}

function getFootprintData(code, date) {
	return new Promise((resolve, reject) => {
		dashApi
			.getFootprintData(code, date)
			.then((response) => {
				if (response.success === true) {
					resolve(response.data);
				} else {
					reject(response);
				}
			})
			.catch(reject);
	});
}

function getSummaryData(code) {
	return new Promise((resolve, reject) => {
		dashApi
			.getSummaryData(code)
			.then((response) => {
				if (response.success === true) {
					resolve(response.data);
				} else {
					reject(response);
				}
			})
			.catch(reject);
	});
}

function getTableData(code, date) {
	return new Promise((resolve, reject) => {
		dashApi
			.getTableData(code, date)
			.then((response) => {
				if (response.success === true) {
					resolve(response.data);
				} else {
					reject(response);
				}
			})
			.catch(reject);
	});
}

function getIconForCode(code, iconClass) {
	if (iconClass) {
	} else {
		iconClass = "mx-auto pt-1 text-xl xs:text-xl";
	}

	switch (code?.toLowerCase()) {
		case "eq5d-5l":
			return <span className={`${iconClass} ss-icon`}>&#xF000;</span>;
		case "lcss":
			return <span className={`${iconClass} ss-icon`}>&#x2691;</span>;
		case "experience":
			return <span className={`${iconClass} ss-icon`}>&#x1F3C6;</span>;
		case "cost":
			return <span className={`${iconClass} ss-icon`}>&#xE545;</span>;
		case "fact-g7":
			return <span className={`${iconClass} ss-icon`}>&#x2665;</span>;
		case "start-mr":
			return <span className={`${iconClass} ss-icon`}>&#x1F5D8;</span>;
		case "sideeffects":
			return <span className={`${iconClass} ss-icon ss-thermometer`}></span>;
		case "prehab":
			return <span className={`${iconClass} ss-icon ss-pulse`}></span>;
		case "registration_meso":
		case "registration_lcn":
			return <span className={`${iconClass} ss-icon ss-userprofile`}></span>;
		case "clinical":
		case "meso":
		case "mesoperitoneal":
		case "lcnuk":
			return <span className={`${iconClass} ss-icon`}>&#x1F4CB;</span>;
		default:
			return <span className={`${iconClass} ss-icon`}>&#x1F5D8;</span>;
	}
}

function setIsOnChartScreen(value) {
	isOnChartScreenValue = value;
}

function isOnChartScreen() {
	return isOnChartScreenValue;
}

export {
	getSummaryDefinitions,
	loadSummaryDefinitions,
	getTimechartData,
	getFootprintData,
	getSummaryData,
	getIconForCode,
	getTableData,
	isOnChartScreen,
	setIsOnChartScreen,
};
